import { CountryCodeEnum } from 'features/common/types';
import { PassengerServiceItem, PassengerServicesData } from './groupServicesByPassenger';

const TAXABLE_BASE_RATE = 0.25;
const VAT_RATE = 0.1;

export interface FlightVatBreakdown {
	taxableBase: number;
	vat: number;
}

export const isParaguayAgency = (country: CountryCodeEnum): boolean =>
	country === CountryCodeEnum.PARAGUAY || country === CountryCodeEnum.TN_ITAU_PY;

export const flightHasAsuLeg = (flightLegs?: any[]): boolean => {
	if (!flightLegs || flightLegs.length === 0) return false;
	return flightLegs.some((leg) => leg.departure?.airport?.code === 'ASU' || leg.arrival?.airport?.code === 'ASU');
};

export const getFlightVatBreakdown = (
	service: PassengerServiceItem,
	country: CountryCodeEnum,
): FlightVatBreakdown | null => {
	if (!isParaguayAgency(country)) return null;
	if (service.serviceType !== 'Flight') return null;
	if (!flightHasAsuLeg(service.flightLegs)) return null;

	const taxableBase = service.saleAmount * TAXABLE_BASE_RATE;
	const vat = taxableBase * VAT_RATE;
	return { taxableBase, vat };
};

const sumVatBreakdowns = (breakdowns: (FlightVatBreakdown | null)[]): FlightVatBreakdown =>
	breakdowns.reduce(
		(acc, b) => {
			if (!b) return acc;
			return { taxableBase: acc.taxableBase + b.taxableBase, vat: acc.vat + b.vat };
		},
		{ taxableBase: 0, vat: 0 },
	);

export const getPassengerVatTotals = (services: PassengerServiceItem[], country: CountryCodeEnum): FlightVatBreakdown =>
	sumVatBreakdowns(services.map((s) => getFlightVatBreakdown(s, country)));

export const getOrderVatTotals = (
	passengerServices: PassengerServicesData[],
	country: CountryCodeEnum,
): FlightVatBreakdown =>
	sumVatBreakdowns(passengerServices.flatMap((pd) => pd.services.map((s) => getFlightVatBreakdown(s, country))));
